import { Component, inject, model, ModelSignal, OnDestroy, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { I18nService } from 'ncp-lib';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Languages } from '@core/enums';
import { filter, merge } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { APIService } from '@core/services';
import * as translations from '../translations';
import {environment} from '@env/environment';
import {PROJECTS} from '@core/constants';

export let browserRefresh: ModelSignal<boolean>;

@UntilDestroy()
@Component({
  selector: 'ncp-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('NCPeH-Providers_Upgrade');
  protected _bowserRefresh = model<boolean>(false);

  private readonly titleService = inject(Title);
  private readonly apiService = inject(APIService);
  private readonly i18nService = inject(I18nService);
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);

  public url = window.location.hostname;

  ngOnInit(): void {
    console.log('entry url = ' + this.url);
    // TODO: set environment here // providers or beneficiaries //window.href
    browserRefresh = this._bowserRefresh;

    this.i18nService.translations = translations;
    this.i18nService.init(Languages.greek, [Languages.english, Languages.greek, Languages.turkish]);

    const onNavigationEnd = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );

    merge(this.translateService.onLangChange, onNavigationEnd)
      .pipe(untilDestroyed(this))
      .subscribe((event) => {
        this.titleService.setTitle(this.translateService.instant(environment.project === PROJECTS.PROVIDERS ? 'title_providers' : 'title_beneficiaries'));
      });

    this.apiService.init();
  }

  ngOnDestroy(): void {
    this.i18nService.destroy();
  }
}
